export default __webpack_public_path__ + "static/media/sys_logo_colour.5bb8f732.svg";